
export const setOrders = (orders) => {
    return {
        type: 'SET_ORDERS',
        orders,
    };
};


export const selectOrder = (order) => {
    return {
        type: 'SELECT_ORDER',
        order,
    };
};

export const setFilter = (filter) => {
    return {
        type: 'SET_FILTER',
        filter,
    };
};


export const resetFilter = () => {
    return {
        type: 'RESET_FILTER'
    };
};

